module.exports = __webpack_public_path__ + "img/CH.68584d5a.svg";